"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerAlert = exports.BmAlert = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _bmIcons = require("./bm-icons");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t\t<span>\n\t\t\t\t<slot></slot>\n\t\t\t</span>\n\t\t\t<div @click=\"", "\">\n\t\t\t", "\n\t\t\t</div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: flex;\n\t\tcontain: content;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\tpadding: 11px 10px;\n\n\t\tborder: none;\n\t\ttransition: 0.2s linear all;\n\t\tbox-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.3);\n\t\ttransition: opacity 0.5s, filter 0.5s;\n\t\tborder-radius: 5px;\n\t\ttransition: opacity 0.5s, filter 0.5s, -webkit-filter 0.5s;\n\t}\n\n\t:host span {\n\t\tflex-grow: 1;\n\t\tfont-size: 15px;\n\t\tfont-family: Arial, 'Helvetica Neue', sans-serif;\n\t\ttext-align: left;\n\t}\n\t:host svg {\n\t\tmargin-right: 10px;\n\t\tflex-shrink: 0;\n\t}\n\n\t:host svg.close {\n\t\tcursor: pointer;\n\t\tmargin-right: 0;\n\t}\n\n\t:host svg.close:hover {\n\t\tbackground: #fff;\n\t\tborder-radius: 12px;\n\t}\n\n\t:host([type='danger']) {\n\t\tbackground: #dc0a0a;\n\t\tbackground: var(--danger, #dc0a0a);\n\t\tcolor: #fff;\n\t\tfill: #fff;\n\t}\n\t:host([type='success']) {\n\t\tbackground: #387c2b;\n\t\tbackground: var(--success, #387c2b);\n\t\tcolor: #fff;\n\t\tfill: #fff;\n\t}\n\t:host([type='warning']) {\n\t\tbackground: #ffb400;\n\t\tbackground: var(--warning, #ffb400);\n\t\tcolor: #000;\n\t\tfill: #000;\n\t}\n\t:host([type='info']) {\n\t\tbackground: #0072a8;\n\t\tbackground: var(--info, #0072a8);\n\t\tcolor: #fff;\n\t\tfill: #fff;\n\t}\n\t:host([type='danger']) svg.close:hover {\n\t\tfill: #dc0a0a;\n\t\tfill: var(--danger, #dc0a0a);\n\t}\n\t:host([type='success']) svg.close:hover {\n\t\tfill: #387c2b;\n\t\tfill: var(--success, #387c2b);\n\t}\n\t:host([type='warning']) svg.close:hover {\n\t\tfill: #ffb400;\n\t\tfill: var(--warning, #ffb400);\n\t}\n\t:host([type='info']) svg.close:hover {\n\t\tfill: #0072a8;\n\t\tfill: var(--info, #0072a8);\n\t}\n\t:host svg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n\t:host div svg {\n\t\twidth: 15px;\n\t\theight: 15px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmAlert = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmAlert, _BlueElement);

  var _super = (0, _createSuper2.default)(BmAlert);

  function BmAlert() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.type = 'info';
    _this.closeable = false;
    return _this;
  }

  (0, _createClass2.default)(BmAlert, [{
    key: "closeAlert",
    value: function closeAlert() {
      this.dispatchEvent(new CustomEvent('close'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _context2;

      return this.html(_templateObject2(), (0, _element.guard)(this.type, function () {
        return _this2.renderIcon(_this2.type);
      }), (0, _bind.default)(_context2 = this.closeAlert).call(_context2, this), (0, _element.cache)(this.closeable ? _bmIcons.close : null));
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(type) {
      if (type === 'info') {
        return _bmIcons.info;
      }

      if (type === 'success') {
        return _bmIcons.success;
      }

      if (type === 'danger') {
        return _bmIcons.danger;
      }

      if (type === 'warning') {
        return _bmIcons.panTool;
      }

      return null;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-alert';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        type: {
          type: String,
          attribute: true,
          reflect: true
        },
        closeable: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmAlert;
}(_element.BlueElement);

exports.BmAlert = BmAlert;

var registerAlert = function registerAlert() {
  return (0, _element.register)(BmAlert);
};

exports.registerAlert = registerAlert;
